<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<p class="dedicationText"><em class="italic">To the Carrigans of Portland Mark, Kim, Clay, and Jesse</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_ded01.vue?4d3d1a3d